// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Eq_Generic from "../Data.Eq.Generic/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Index from "../Foreign.Index/index.js";
import * as Restaumatic_Address from "../Restaumatic.Address/index.js";
import * as Restaumatic_I18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic_Orders_Types_FulfillmentMethodType from "../Restaumatic.Orders.Types.FulfillmentMethodType/index.js";
import * as Restaumatic_Orders_Types_PaymentMethod from "../Restaumatic.Orders.Types.PaymentMethod/index.js";
import * as Restaumatic_Site_Translations_Keys from "../Restaumatic.Site.Translations.Keys/index.js";
import * as Restaumatic_Types from "../Restaumatic.Types/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var Phone = function (x) {
    return x;
};
var Email = /* #__PURE__ */ (function () {
    function Email(value0) {
        this.value0 = value0;
    };
    Email.create = function (value0) {
        return new Email(value0);
    };
    return Email;
})();
var NoEmail = /* #__PURE__ */ (function () {
    function NoEmail() {

    };
    NoEmail.value = new NoEmail();
    return NoEmail;
})();
var DeliveryMethodPickup = /* #__PURE__ */ (function () {
    function DeliveryMethodPickup() {

    };
    DeliveryMethodPickup.value = new DeliveryMethodPickup();
    return DeliveryMethodPickup;
})();
var DeliveryMethodShipment = /* #__PURE__ */ (function () {
    function DeliveryMethodShipment(value0) {
        this.value0 = value0;
    };
    DeliveryMethodShipment.create = function (value0) {
        return new DeliveryMethodShipment(value0);
    };
    return DeliveryMethodShipment;
})();
var DeliveryMethodDineIn = /* #__PURE__ */ (function () {
    function DeliveryMethodDineIn(value0) {
        this.value0 = value0;
    };
    DeliveryMethodDineIn.create = function (value0) {
        return new DeliveryMethodDineIn(value0);
    };
    return DeliveryMethodDineIn;
})();
var DeliveryMethodNoContactDelivery = /* #__PURE__ */ (function () {
    function DeliveryMethodNoContactDelivery(value0) {
        this.value0 = value0;
    };
    DeliveryMethodNoContactDelivery.create = function (value0) {
        return new DeliveryMethodNoContactDelivery(value0);
    };
    return DeliveryMethodNoContactDelivery;
})();
var AnonymousUser = /* #__PURE__ */ (function () {
    function AnonymousUser() {

    };
    AnonymousUser.value = new AnonymousUser();
    return AnonymousUser;
})();
var RegisteredUser = /* #__PURE__ */ (function () {
    function RegisteredUser(value0) {
        this.value0 = value0;
    };
    RegisteredUser.create = function (value0) {
        return new RegisteredUser(value0);
    };
    return RegisteredUser;
})();
var showPhone = Data_Show.showString;
var newtypePhone_ = {
    Coercible0: function () {
        return undefined;
    }
};
var genericEmail_ = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new Email(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return NoEmail.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Order.Types (line 125, column 1 - line 125, column 32): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Email) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof NoEmail) {
            return new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value);
        };
        throw new Error("Failed pattern match at Restaumatic.Order.Types (line 125, column 1 - line 125, column 32): " + [ x.constructor.name ]);
    }
};
var showEmail = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericEmail_)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showString))({
        reflectSymbol: function () {
            return "Email";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "NoEmail";
        }
    })))
};
var toFulfillmentMethodType = function (deliveryMethod) {
    if (deliveryMethod instanceof DeliveryMethodPickup) {
        return Restaumatic_Orders_Types_FulfillmentMethodType.Takeaway.value;
    };
    if (deliveryMethod instanceof DeliveryMethodShipment) {
        return Restaumatic_Orders_Types_FulfillmentMethodType.Delivery.value;
    };
    if (deliveryMethod instanceof DeliveryMethodDineIn) {
        return Restaumatic_Orders_Types_FulfillmentMethodType.DineIn.value;
    };
    if (deliveryMethod instanceof DeliveryMethodNoContactDelivery) {
        return Restaumatic_Orders_Types_FulfillmentMethodType.NoContactDelivery.value;
    };
    throw new Error("Failed pattern match at Restaumatic.Order.Types (line 81, column 42 - line 85, column 61): " + [ deliveryMethod.constructor.name ]);
};
var sequenceDeliveryMethod = function (dictApplicative) {
    return function (v) {
        if (v instanceof DeliveryMethodPickup) {
            return Control_Applicative.pure(dictApplicative)(DeliveryMethodPickup.value);
        };
        if (v instanceof DeliveryMethodShipment) {
            return Data_Functor.map((dictApplicative.Apply0()).Functor0())(function ($59) {
                return DeliveryMethodShipment.create(Data_Identity.Identity($59));
            })(v.value0);
        };
        if (v instanceof DeliveryMethodDineIn) {
            return Data_Functor.map((dictApplicative.Apply0()).Functor0())(function ($60) {
                return DeliveryMethodDineIn.create(Data_Identity.Identity($60));
            })(v.value0);
        };
        if (v instanceof DeliveryMethodNoContactDelivery) {
            return Data_Functor.map((dictApplicative.Apply0()).Functor0())(function ($61) {
                return DeliveryMethodNoContactDelivery.create(Data_Identity.Identity($61));
            })(v.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Order.Types (line 74, column 3 - line 78, column 90): " + [ v.constructor.name ]);
    };
};
var paymentMethodDescription = function (v) {
    if (v instanceof Restaumatic_Orders_Types_PaymentMethod.Cash) {
        return Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.payment_method.cash.label);
    };
    if (v instanceof Restaumatic_Orders_Types_PaymentMethod.Card) {
        return Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.payment_method.card.label);
    };
    if (v instanceof Restaumatic_Orders_Types_PaymentMethod.Online) {
        return Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.payment_method.online.label);
    };
    if (v instanceof Restaumatic_Orders_Types_PaymentMethod.Prepaid) {
        return "";
    };
    if (v instanceof Restaumatic_Orders_Types_PaymentMethod.Offline) {
        return Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.payment_method.online.offline);
    };
    if (v instanceof Restaumatic_Orders_Types_PaymentMethod.CashAndCard) {
        return Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.payment_method.online.cashAndCard);
    };
    if (v instanceof Restaumatic_Orders_Types_PaymentMethod.BankTransfer) {
        return Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.payment_method.bank_transfer.label);
    };
    throw new Error("Failed pattern match at Restaumatic.Order.Types (line 45, column 3 - line 52, column 68): " + [ v.constructor.name ]);
};
var hoistDeliveryMethod = function (f) {
    return function (v) {
        if (v instanceof DeliveryMethodPickup) {
            return DeliveryMethodPickup.value;
        };
        if (v instanceof DeliveryMethodShipment) {
            return new DeliveryMethodShipment(f(v.value0));
        };
        if (v instanceof DeliveryMethodDineIn) {
            return new DeliveryMethodDineIn(f(v.value0));
        };
        if (v instanceof DeliveryMethodNoContactDelivery) {
            return new DeliveryMethodNoContactDelivery(f(v.value0));
        };
        throw new Error("Failed pattern match at Restaumatic.Order.Types (line 65, column 3 - line 69, column 79): " + [ v.constructor.name ]);
    };
};
var genericDeliveryMethod = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return DeliveryMethodPickup.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new DeliveryMethodShipment(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new DeliveryMethodDineIn(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
            return new DeliveryMethodNoContactDelivery(x.value0.value0.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Order.Types (line 90, column 1 - line 90, column 71): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof DeliveryMethodPickup) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof DeliveryMethodShipment) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof DeliveryMethodDineIn) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof DeliveryMethodNoContactDelivery) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0)));
        };
        throw new Error("Failed pattern match at Restaumatic.Order.Types (line 90, column 1 - line 90, column 71): " + [ x.constructor.name ]);
    }
};
var showDeliveryMethod = function (dictShow) {
    return function (dictShow1) {
        return {
            show: Data_Show_Generic.genericShow(genericDeliveryMethod)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
                reflectSymbol: function () {
                    return "DeliveryMethodPickup";
                }
            }))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(dictShow))({
                reflectSymbol: function () {
                    return "DeliveryMethodShipment";
                }
            }))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(dictShow1))({
                reflectSymbol: function () {
                    return "DeliveryMethodDineIn";
                }
            }))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(dictShow))({
                reflectSymbol: function () {
                    return "DeliveryMethodNoContactDelivery";
                }
            })))))
        };
    };
};
var eqDeliveryMethod = function (dictEq) {
    return function (dictEq1) {
        return {
            eq: Data_Eq_Generic.genericEq(genericDeliveryMethod)(Data_Eq_Generic.genericEqSum(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(Data_Eq_Generic.genericEqSum(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(dictEq)))(Data_Eq_Generic.genericEqSum(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(dictEq1)))(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(dictEq))))))
        };
    };
};
var encodeDeliveryMethodType = {
    encode: function (v) {
        if (v instanceof DeliveryMethodPickup) {
            return Foreign_Generic_Class.encode(Foreign_Generic_Class.stringEncode)("pickup");
        };
        if (v instanceof DeliveryMethodShipment) {
            return Foreign_Generic_Class.encode(Foreign_Generic_Class.stringEncode)("shipment");
        };
        if (v instanceof DeliveryMethodDineIn) {
            return Foreign_Generic_Class.encode(Foreign_Generic_Class.stringEncode)("dine_in");
        };
        if (v instanceof DeliveryMethodNoContactDelivery) {
            return Foreign_Generic_Class.encode(Foreign_Generic_Class.stringEncode)("no_contact_delivery");
        };
        throw new Error("Failed pattern match at Restaumatic.Order.Types (line 99, column 5 - line 103, column 72): " + [ v.constructor.name ]);
    }
};
var decodeDeliveryMethodType = {
    decode: function (f) {
        return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign.readString(Data_Identity.monadIdentity)(f))(function (str) {
            if (str === "pickup") {
                return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(DeliveryMethodPickup.value);
            };
            if (str === "shipment") {
                return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(new DeliveryMethodShipment(Type_Proxy["Proxy"].value));
            };
            if (str === "dine_in") {
                return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(new DeliveryMethodDineIn(Type_Proxy["Proxy"].value));
            };
            if (str === "no_contact_delivery") {
                return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(new DeliveryMethodNoContactDelivery(Type_Proxy["Proxy"].value));
            };
            return Foreign.fail(Data_Identity.monadIdentity)(new Foreign.ForeignError("Invalid DeliveryMethodType: " + Data_Show.show(Data_Show.showString)(str)));
        });
    }
};
var decodeCurrentUser = {
    decode: function (f) {
        return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Index.index(Foreign_Index.indexString(Data_Identity.monadIdentity))(f)("signed_in"))(Foreign.readBoolean(Data_Identity.monadIdentity)))(function (signedIn) {
            if (signedIn) {
                return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Generic_Class.decode(Foreign_Generic_Class.recordDecode()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
                    reflectSymbol: function () {
                        return "parsed_phone";
                    }
                })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
                    reflectSymbol: function () {
                        return "full_name";
                    }
                })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
                    reflectSymbol: function () {
                        return "email";
                    }
                })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))()))(f))(function (v) {
                    return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(new RegisteredUser({
                        email: new Email(v.email),
                        fullName: new Data_Maybe.Just(v.full_name),
                        phone: new Data_Maybe.Just(v.parsed_phone)
                    }));
                });
            };
            return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(AnonymousUser.value);
        });
    }
};
export {
    paymentMethodDescription,
    DeliveryMethodPickup,
    DeliveryMethodShipment,
    DeliveryMethodDineIn,
    DeliveryMethodNoContactDelivery,
    hoistDeliveryMethod,
    sequenceDeliveryMethod,
    toFulfillmentMethodType,
    Email,
    NoEmail,
    Phone,
    genericDeliveryMethod,
    eqDeliveryMethod,
    showDeliveryMethod,
    encodeDeliveryMethodType,
    decodeDeliveryMethodType,
    genericEmail_,
    showEmail,
    newtypePhone_,
    showPhone
};
export {
    AddressExtra,
    DeliveryAddress,
    Block,
    House,
    LocatedDeliveryAddress,
    displayHouseOrBlock,
    emptyAddressExtra,
    formatAddressForDisplay,
    formatCountrySpecificAddress,
    isPostCodeRequired
} from "../Restaumatic.Address/index.js";
export {
    BankTransfer,
    Card,
    Cash,
    CashAndCard,
    Offline,
    Online,
    Prepaid
} from "../Restaumatic.Orders.Types.PaymentMethod/index.js";
export {
    RestaurantId
} from "../Restaumatic.Types/index.js";
//# sourceMappingURL=index.js.map
